import React from 'react';
import './SignUpPage.css';

const SignUp = () => {
  return (
    <div className="signup-page">
      <div className="signup-container">
        <h2>Sign Up</h2>
        <p>Account creation is coming soon.</p>
        <div className="signup-links">
          <p>Have an account? <a href="/login">Log in here</a></p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
